import { supabase } from '../lib/supabaseClient';

export interface ActionCountermeasureRecord {
  actionId: string;
  issueId: string;
  whereText: string | null;
  howText: string | null;
  costAmount: number | null;
  costCurrency: string | null;
}

interface ActionCountermeasureRow {
  action_id: string;
  issue_id: string;
  where_text: string | null;
  how_text: string | null;
  cost_amount: number | string | null;
  cost_currency: string | null;
}

function toRecord(row: ActionCountermeasureRow): ActionCountermeasureRecord {
  const amount = row.cost_amount == null || row.cost_amount === '' ? null : Number(row.cost_amount);
  return {
    actionId: row.action_id,
    issueId: row.issue_id,
    whereText: row.where_text,
    howText: row.how_text,
    costAmount: amount != null && Number.isFinite(amount) ? amount : null,
    costCurrency: row.cost_currency,
  };
}

function fail(error: { code?: string; message?: string } | null, fallback: string): never {
  if (error?.code === '23514') throw new Error('A extensão precisa da mesma ação, do mesmo problema e da mesma organização.');
  throw new Error(error?.message || fallback);
}

/** Onde, como e custo. O quê, por quê, quem e quando permanecem na ação. */
export async function listActionCountermeasures(
  organizationId: string,
  issueId: string,
): Promise<ActionCountermeasureRecord[]> {
  const { data, error } = await supabase
    .from('action_countermeasures')
    .select('action_id, issue_id, where_text, how_text, cost_amount, cost_currency')
    .eq('organization_id', organizationId)
    .eq('issue_id', issueId);
  if (error) fail(error, 'Não foi possível ler o 5W2H.');
  return ((data ?? []) as ActionCountermeasureRow[]).map(toRecord);
}

export async function saveActionCountermeasure(input: {
  organizationId: string;
  issueId: string;
  actionId: string;
  whereText: string | null;
  howText: string | null;
  costAmount: number | null;
  costCurrency: string | null;
}): Promise<void> {
  const { error } = await supabase.from('action_countermeasures').upsert({
    action_id: input.actionId,
    issue_id: input.issueId,
    organization_id: input.organizationId,
    where_text: input.whereText,
    how_text: input.howText,
    cost_amount: input.costAmount,
    cost_currency: input.costCurrency,
  }, { onConflict: 'action_id' });
  if (error) fail(error, 'Não foi possível registrar onde, como e custo.');
}
